import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MsalInterceptor } from '@azure/msal-angular';

export const msalAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return next(req);
  }

  const msalInterceptor = inject(MsalInterceptor);
  return msalInterceptor.intercept(req, { handle: next });
};
